/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
import schema_properties from '@bingads-webui-component-legacy/grid/schema/properties';
import Response from '@bingads-webui-component-legacy/grid/model/response';
var Model = BaseProjection.extend({
  defaults: {
    'page.size': 20,
    'page.number': 0
  },
  name: 'page',
  beforeSet: function (local, other) {
    var size = _.has(local, 'page.size') ? local['page.size'] : this.get('page.size'), number = _.has(local, 'page.number') ? local['page.number'] : this.get('page.number');
    size = Math.max(size, 0);
    number = Math.max(number, 0);
    _.extend(other, {
      take: size,
      skip: size * number
    });
  },
  update: function (options) {
    var options = options || ({});
    if (options.deep) {
      if (this.src) {
        var size = Math.max(this.get('page.size'), 0), number = Math.max(this.get('page.number'), 0);
        this.src.set({
          take: size,
          skip: size * number
        }, {
          silent: true
        });
      }
    }
    if (Model.__super__.update.call(this, options)) {
      var model = this.src.data, count = Math.max(0, model.get('count')), size = this.get('page.size'), page_count = Math.ceil(count / size);
      this.patch({
        'page.count': page_count
      });
    } else {}
  }
});
export default Model;

